<template>
  <div class="Inquiry">
    <transition name="el-fade-in-linear">
      <Bounced ref="child" />
    </transition>
    <div class="sidebar">
      <div class="warp">
        <ul>
          <li class="li_1" @click="Pop_up">
            <div class="warp_btn">
              <span class="iocn"></span>
              <span class="text">在线咨询</span>
            </div>
          </li>
          <li class="li_2">
            <div class="warp_btn">
              <span class="iocn"></span>
              <span class="text">电话咨询</span>
            </div>
            <div class="warp_con">
              <div class="warp_text">
                <span>+86 010-68618216</span>
              </div>
            </div>
          </li>
          <li class="li_3">
            <div class="warp_btn">
              <span class="iocn"></span>
              <span class="text">技术支持</span>
            </div>
            <div class="warp_con">
              <div class="warp_text">
                <span>+86 010-68618216</span>
              </div>
            </div>
          </li>
          <li class="li_4">
            <div class="warp_btn">
              <span class="iocn"></span>
              <span class="text">微信咨询</span>
            </div>
            <!-- <div class="warp_con">
              <div class="warp_img">
                <img src="./../assets/img/erweima.png" alt="MPA联合体" />
              </div>
            </div> -->
          </li>
          <li class="li_5" v-if="btnFlag" @click="backTop">
            <div class="warp_btn clearfix">
              <span class="iocn"></span>
              <span class="text">返回顶部</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="phone">
      <!-- <a href="tel:010-88686211" class="tel"><span>联系我们</span></a> -->
      <a @click="Pop_up">
        <span>联系我们</span>
      </a>
      <div class="top" v-if="btnFlag" @click="backTop"></div>
    </div>
  </div>
</template>

<script>
import Bounced from './Bounced.vue'

export default {
  name: 'Inquiry',
  components: {
    Bounced
    // Jre
  },
  props: {
  },
  data () {
    return {
      btnFlag: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    Pop_up: function () {
      this.$refs.child.on()
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
      const that = this
      const timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "./../assets/color.less";

.Inquiry {
  position: fixed;
  right: 4px;
  top: 40%;
  margin-top: -82px;
  width: auto;
  height: auto;
  z-index: 9999;
  .sidebar {
    .warp {
      ul {
        // position: fixed;
        // top: 50%;
        // margin-top: -162px;
        // right: 0;
        // z-index: 1000;
        li {
          height: 50px;
          position: relative;
          .warp_btn {
            padding-left: 17px;
            position: absolute;
            right: 0;
            overflow: hidden;
            border-bottom: 1px solid rgba(255, 255, 255, 0.4);
            width: 50px;
            height: 50px;
            background: rgba(53, 63, 88, 0.66);
            text-align: center;
            line-height: 50px;
            cursor: pointer;
            transition: width 0.3s ease;
            -webkit-transition: width 0.3s ease;
            -o-transition: width 0.3s ease;
            -moz-transition: width 0.3s ease;
            span.iocn {
              float: left;
              display: block;
              margin-top: 17px;
              width: 16px;
              height: 16px;
            }
            span.text {
              float: left;
              display: none;
              font-size: 14px;
              color: #fff;
              line-height: 50px;
            }
          }
          .warp_con {
            position: relative;
            position: absolute;
            padding: 12px;
            right: 117px;
            top: 0;
            visibility: hidden;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 12px 0px rgba(230, 230, 230, 0.5);
            border: 1px solid rgba(241, 243, 245, 1);
            transition: width 0.3s ease;
            -webkit-transition: width 0.3s ease;
            -o-transition: width 0.3s ease;
            -moz-transition: width 0.3s ease;
            .warp_img {
              width: 90px;
              height: 90px;
              background-color: whitesmoke;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .warp_text {
              span {
                display: block;
                font-size: 14px;
                line-height: 24px;
                color: #434343;
                text-align: left;
              }
            }
          }
          .warp_con::after {
            content: "";
            position: absolute;
            top: 10px;
            right: -12px;
            width: 0;
            z-index: 0;
            height: 0;
            border-left: 12px solid white;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
          }
        }
        li:hover {
          .warp_btn {
            background: linear-gradient(
              127deg,
              rgba(47, 128, 237, 1) 0%,
              rgba(86, 204, 242, 1) 100%
            );
            width: 105px;
            height: 50px;
            padding-left: 12px;
            text-align: left;
            border-radius: 2px 0 0 2px;
            border: none;
            span.iocn {
              margin-right: 8px;
            }
            span.text {
              display: block;
            }
          }
          .warp_con {
            visibility: visible;
          }
        }
        li:nth-child(1) {
          .warp_btn {
            span.iocn {
              background: url("./../assets/img/sidebar_iocn_01.png")
                no-repeat top center;
              background-size: 100% auto;
            }
          }
        }
        li:nth-child(2) {
          .warp_btn {
            span.iocn {
              background: url("./../assets/img/sidebar_iocn_02.png")
                no-repeat top center;
              background-size: 100% auto;
            }
          }
          .warp_con {
            .warp_text {
              width: 120px;
            }
          }
        }
        li:nth-child(3) {
          .warp_btn {
            span.iocn {
              background: url("./../assets/img/sidebar_iocn_03.png")
                no-repeat top center;
              background-size: 100% auto;
            }
          }
          .warp_con {
            .warp_text {
              width: 176px;
            }
          }
        }
        li:nth-child(4) {
          .warp_btn {
            border-bottom: none;
            span.iocn {
              background: url("./../assets/img/sidebar_iocn_04.png")
                no-repeat top center;
              background-size: 100% auto;
            }
          }
        }
        li:nth-child(5) {
          margin-top: 6px;
          .warp_btn {
            border-bottom: none;
            span.iocn {
              background: url("./../assets/img/top.png") no-repeat top
                center;
              background-size: 100% auto;
            }
          }
        }
      }
    }
  }
  .phone {
    display: none;
    a {
      padding: 34px 12px 12px 12px;
      display: block;
      background: url("./../assets/img/inquiry.png") no-repeat top center;
      background-size: 24px auto;
      background-position-y: 6px;
      background-color: @theme_blue;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
      span {
        font-size: 14px;
        line-height: 16px;
        color: @white;
      }
    }
    .top {
      margin-top: 6px;
      width: 40px;
      height: 40px;
      border: 1px solid @font_black_85;
      background: url("./../assets/img/up.png") no-repeat center;
      background-size: 24px auto;
      background-color: @white;
      border-radius: 4px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }
}
@media all and (max-width: 768px) {
  .Inquiry {
    top: 55%;
    .sidebar {
      display: none;
    }
    .phone {
      display: block;
      a {
        width: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Inquiry.vue